import { SET_AUTH_LABEL, TOGGLE_SIDEBAR } from './auxiliaryActionTypes';

export const setLabel = (path) => ({
  type: SET_AUTH_LABEL,
  payload: path
});
export const toggleSideBar = (data) => ({
  type: TOGGLE_SIDEBAR,
  payload: data
});
